import React from "react";
import PropTypes from "prop-types";
import { VscChromeMinimize } from "react-icons/vsc";
import { ImPhoneHangUp } from "react-icons/im";
import { defaultChatBotSettings } from "../../consts/settings";

function VoiceHeader({ settingsState, chatBotSetting, toggleVoiceMode }) {
  return (
    <div
      style={{
        backgroundColor: chatBotSetting.headerBackgroundColor,
      }}
      className="flex items-center justify-between w-full h-14 px-5"
    >
      <div className="chat-plugin-text flex items-center gap-4">
        <div>
          <h3 className="text-base font-semibold text-white">
            {chatBotSetting.title || defaultChatBotSettings.title}
          </h3>
        </div>
      </div>
      <div className="chat-plugin-option flex items-center gap-2">
        <button
          onClick={toggleVoiceMode}
          className="w-7 h-7 bg-transparent flex items-center justify-center"
        >
          <ImPhoneHangUp size={17} className="invert " />
        </button>
        <button
          className="w-7 h-7 bg-transparent flex items-center justify-center"
        >
          <VscChromeMinimize size={19} className="invert" />
        </button>
      </div>
    </div>
  );
}

VoiceHeader.propTypes = {
  settingsState: PropTypes.any,
  chatBotSetting: PropTypes.any,
  toggleVoiceMode: PropTypes.func.isRequired,
};

export default VoiceHeader;
